import classNames from 'classnames';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card} from 'reactstrap';
import {withRouter} from 'react-router-dom';
import dashboardSelectors from '../../store/dashboard/selectors';
import dashboardActionCreators from '../../store/dashboard/action-creators';
import oitsActionCreators from '../../store/oits/action-creators/index';
import OitProgressBar from '../../../shared/components/OitProgressBar';
import myTrainingProgramActionCreators from '../../store/my-training-program/action-creators';
import trainingPhasesActions from '../../store/training-phases/action-creators';
import Modal from '../../../shared/ui/Modal';
import ObservationPhaseDetail from '../training-phases/ObservationPhaseDetail';
import OrientationPhaseDetail from '../training-phases/OrientationPhaseDetail';
import {trainingPhaseFromIncluded} from '../../models/training-phase';
import departmentSelectors from '../../store/department/selectors';
import trainingPhasesSelectors from '../../store/training-phases/selectors';
import ScheduleReports from '../reports/ScheduleReports';
import './OitProgressChart.scss';
import departmentSettingsSelectors from "../../store/department-settings/selectors";
import ReportViewSplit from "../reports/ReportViewSplit";
import ModalSplit from "../../../shared/ui/ModalSplit";
import ReportEditSplit from "../reports/ReportEditSplit";
import ScheduledReportAddSplit from "../reports/ScheduleReportAddSplit";

class OitProgressChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterBy: 'opened',
      viewingTrainingPhase: null,
    };
  }

  componentDidMount() {
    this.props.fetchTrainingProgramStatsTotalWeeks();

    if (this.props.userContext.hasScope('oit')) {
      this.props.loadMyTrainingProgram();
    } else {
      this.props.loadOitsContainer();
    }
  }

  // -------------
  // Computed
  // --------------

  get getFilteredOits() {
    if (this.props.userContext.hasScope('oit')) {
      return this.props.myProgressChart;
    } else if (this.props.userContext.hasScope('fto')) {
      return this.props.myAssignedOits
        ? this.props.myAssignedOits.filter(this.filterOit.bind(this))
        : null;
    }
    return this.props.oitsProgressChart
      ? this.props.oitsProgressChart.filter(this.filterOit.bind(this))
      : null;
  }

  get canViewTrainingProgramDetails() {
    return this.props.userContext.hasScope(['fto']);
  }

  // -------------
  // Methods
  // --------------

  setFilterBy(filterBy) {
    this.setState({
      filterBy,
    });
    const filter = !filterBy || filterBy==='opened'? 'opened':'all'
    this.props.loadOitsContainer(filter);
  }

  loadReportsForTPs(oitsTPS) {
    Object.keys(oitsTPS).forEach((oitGuid) => {
      this.props.fetchReportsForTrainingPhase(oitsTPS[oitGuid].trainingPhaseGuid);
    });
  }

  isTrainingCompleted(trainingTracker, trainingPhases) {
    return (trainingTracker
      && trainingTracker.status === 'closed')
      || (trainingPhases.length > 0 && trainingPhases.filter((phase) => phase.status === 'completed').length === trainingPhases.length)
  }

  filterOit(oit) {
    if (this.state.filterBy === 'opened') {
      return !oit.trainingTracker || oit.trainingTracker.status === 'opened' || oit.trainingTracker.status === 'paused' || !oit.trainingTracker.status
        && !this.isTrainingCompleted(oit.trainingTracker, oit.trainingPhases);
      // return oit.x < 100 && oit.trainingPhases.length > 0 && oit.active;
    } else if (this.state.filterBy === 'completed') {
      return this.isTrainingCompleted(oit.trainingTracker, oit.trainingPhases);
    }
    return true;
  }

  viewTrainingPhase(trainingPhase) {
    this.props.viewTrainingPhase(trainingPhase.trainingPhaseGuid);
    this.setState({
      viewingTrainingPhase: trainingPhaseFromIncluded(trainingPhase),
    });
  }

  onChangePhase(report) {
    this.setState({
      showChangeReportPhaseDialog: true,
      currentChangePhaseReportGuid: report.guid,
      currentChangePhase: {
        phase: report.trainingPhaseGuid,
        datetime: report.responses[0] && report.responses[0].datetime ? (report.responses[0].datetime.split('T')[0]): null
      }
    })
  }

  render() {
    return (
      <div
        className={classNames('oit-progress-chart', {
          reverse: this.props.reverse,
        })}
      >
        {!this.props.userContext.hasScope('oit') && (
          <form className="table-filters">
            <div className="form-group">
              <label htmlFor="filterByType">Filter {this.props.oitShortLabel}s</label>
              <select
                className="form-control"
                id="filterByType"
                name="filterByType"
                onChange={event => this.setFilterBy(event.target.value)}
                value={this.state.filterBy}
              >
                <option value="opened">In progress</option>
                <option value="completed">Completed</option>
                <option value="all">All</option>
              </select>
            </div>
          </form>
        )}
        <Card className="chart">
          {this.getFilteredOits && (
            <OitProgressBar
              hideTopAxis={this.props.hideTopAxis}
              items={this.getFilteredOits}
              canViewTrainingProgramDetails={false}
              tickValues={[
                '0%',
                '10%',
                '20%',
                '30%',
                '40%',
                '50%',
                '60%',
                '70%',
                '80%',
                '90%',
                '100%',
              ]}
              barColor={item => (item.color)}
              trainingPhasesReports={this.props.trainingPhasesReports}
              onViewDetails={(datapoint) => {
                if (this.props.showMyProgram) {
                  this.props.history.push('my-training-program');
                } else {
                  this.props.history.push(`/oits/${datapoint.guid}/training-program`);
                }
              }}
              onLoadReportsForTP={tps => this.loadReportsForTPs(tps)}
              onViewOpenForms={trainingPhase =>
                this.viewTrainingPhase(trainingPhase)
              }
            />
          )}
        </Card>
        <Modal
          isOpen={this.props.selectedTrainingPhaseModal}
          onClose={() => this.props.closeViewPhase()}
          title={this.phaseDetailsTitle}
        >
          {this.state.viewingTrainingPhase &&
            this.state.viewingTrainingPhase.type === 'observation' && (
              <ObservationPhaseDetail phase={this.state.viewingTrainingPhase} />
            )}
          {this.state.viewingTrainingPhase &&
            this.state.viewingTrainingPhase.type === 'orientation' && (
              <OrientationPhaseDetail phase={this.state.viewingTrainingPhase} />
            )}
        </Modal>

        <ModalSplit
          isOpen={!!this.props.isAddingScheduledReport}
          onClose={() => this.props.closeAddScheduledReport()}
          title={this.props.form && this.props.form.name}
        >
          <ScheduledReportAddSplit/>
        </ModalSplit>

        <ModalSplit
          isOpen={this.props.isEditingReportModalOpened}
          onClose={() => this.props.closeEditReport()}
          title={this.props.editingReport && this.props.editingReport.formName}
        >
          <ReportEditSplit />
        </ModalSplit>

        <ModalSplit
          isOpen={this.props.isViewingReportModalOpened}
          onClose={() => this.props.closeViewReport()}
          title={this.props.report && this.props.report.formName}
        >
          <ReportViewSplit
            phase={this.state.viewingTrainingPhase}
            report={this.props.report}
          />
        </ModalSplit>

        <Modal
          isOpen={this.props.isSchedulingReports}
          onClose={() => this.props.closeScheduleReports()}
          title="Schedule observation reports"
          onChangePhase={report => this.onChangePhase(report)}
        >
          <ScheduleReports />
        </Modal>
      </div>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    userContext: state.common.userContext,
    oitsProgressChart: dashboardSelectors.oitsProgressChart(state),
    myProgressChart: dashboardSelectors.myProgressChart(state),
    myAssignedOits: dashboardSelectors.myAssignedOitsChart(state),
    selectedTrainingPhaseModal: state.trainingPhases.selectedTrainingPhaseModal,
    isAddingScheduledReport: state.trainingPhases.isAddingScheduledReport,
    form: departmentSelectors.selectedFormFor(state),
    isEditingReportModalOpened: state.trainingPhases.isEditingReportModalOpened,
    editingReport: trainingPhasesSelectors.editingReport(state),
    isViewingReportModalOpened: state.trainingPhases.isViewingReportModalOpened,
    report: trainingPhasesSelectors.viewingReport(state),
    trainingPhasesReports: state.trainingPhases.trainingPhasesReports,
    isSchedulingReports: state.trainingPhases.isSchedulingReports,
    oitShortLabel: departmentSettingsSelectors.oitShortLabel(state)
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchTrainingProgramStatsTotalWeeks: () => {
      return dispatch(dashboardActionCreators.fetchTrainingProgramStatsTotalWeeks());
    },
    loadOitsContainer: (status) => {
      return dispatch(oitsActionCreators.loadOitsContainer(null, status));
    },
    loadMyTrainingProgram: () => {
      return dispatch(myTrainingProgramActionCreators.loadMyTrainingProgram());
    },
    viewTrainingPhase: (phaseGuid) => {
      return dispatch(trainingPhasesActions.viewTrainingPhase(phaseGuid));
    },
    fetchReportsForTrainingPhase: (phaseGuid) => {
      return dispatch(trainingPhasesActions.fetchReportsForTrainingPhase(phaseGuid));
    },
    closeViewPhase: () => {
      return dispatch(trainingPhasesActions.closeViewTrainingPhase());
    },
    closeAddScheduledReport: () => {
      dispatch(trainingPhasesActions.closeAddScheduledReport());
    },
    closeEditReport: () => {
      dispatch(trainingPhasesActions.closeEditReport());
    },
    closeViewReport: () => {
      dispatch(trainingPhasesActions.closeViewReport());
    },
    closeScheduleReports: () => {
      return dispatch(trainingPhasesActions.closeScheduleReports());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(OitProgressChart));
